export default "__VITE_ASSET__7fc4f399__"